import React from "react";
import SearchApp from "./headerComponents/SearchApp/index";
import UserAvatarBtn from "./headerComponents/UserAvatarBtn";
import ErorrCentorIcon from "./headerComponents/ErorrCentorIcon";
import IM from "./headerComponents/IM";
import XiaoYou from "./headerComponents/XiaoYou";
import RecordSPR from "./headerComponents/RecordSPR";
import MTZBDate from "./headerComponents/MTZBDate";
import Message from "./headerComponents/Message/Message";
import HelpCenter from "./headerComponents/HelpCenter/index";
import { langCheck, OSnow } from "Pub/js/utils";
import "../components/AccountActivation/intro.css";
import noviceGuideMessage from "Assets/images/noviceGuide/novice-guide-message.gif";
import noviceGuideUsercenter from "Assets/images/noviceGuide/novice-guide-usercenter.gif";
import noviceGuideMtzbdate from "Assets/images/noviceGuide/novice-guide-mtzbdate.gif";
import noviceGuideHelp from "Assets/images/noviceGuide/novice-guide-help.gif";

/**
 * workbench 工作桌面头部右侧集合
 */
class HeaderRight extends React.Component {
    constructor(props) {
        super(props);
        // intro配置项
        this.introOptions = {
            prevLabel: langCheck("0000PUB-000294"), //上一步
            nextLabel: langCheck("0000PUB-000295"), //下一步
            skipLabel: langCheck("0000PUB-000296"), //跳过指引
            doneLabel: langCheck("0000PUB-000297"), // 完成
            exitOnEsc: true, //ESC关闭introOptions
            exitOnOverlayClick: true, //点击叠加层时退出介绍
            keyboardNavigation: true, //键盘导航
            showStepNumbers: false, //显示红色圆圈中的步骤编号
            hidePrev: true, //在第一步中隐藏上一个按钮
            hideNext: true, //在最后一步隐藏下一个按钮
            hideSkipLabel: false,
            tooltipPosition: "auto", //默认工具提示位置
            // highlightClass: 'novice-guide-intro' //默认高亮样式
        };
        try {
            const systemSwitch = JSON.parse(localStorage.getItem('STOREFORSYSTEM'));
            const { vpa, im } = systemSwitch;
            this.state = {
                vpa,
                im,
            };
        } catch (e) {
            this.state = {};
        }
    }
    render() {
        const { vpa, im } = this.state;
        const { groupId, hideSearch, is_cloud_register, deployType, ispreview, userType } = this.props;
        const dataIntroMessage = `
        <img src=${noviceGuideMessage} alt="" class='novice-guide-message' />
        <p>${langCheck("0000PUB-000300")}</p>
        <div class='span-box'>
            <span>${langCheck("0000PUB-000301")}</span>
        </div>
        <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
        `;

        const dataIntroUser = `
        <img src=${noviceGuideUsercenter} alt="" class='novice-guide-usercenter' />
        <p>${langCheck("0000PUB-000306")}<a class="close-intro" onclick="handleWorkbenchIntro('close')">${langCheck("0000PUB-000296")}</a></p>
        <div class='span-box'>
            <span>${langCheck("0000PUB-000307")}</span>
        </div>
        <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
       `;

        const dataIntroDate = `
        <img src=${noviceGuideMtzbdate} alt="" class='novice-guide-mtzbdate' />
        <p>${langCheck("0000PUB-000304")}</p>
        <div class='span-box'>
            <span>${langCheck("0000PUB-000305")}</span>
        </div>
        <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
       `;
        let helpHotkeyText = langCheck("0000PUB-000482");
        if (OSnow() === 'mac') {
            helpHotkeyText = langCheck("0000PUB-000610");
        }
        const helpCenterIntro = `
        <img src=${noviceGuideHelp} alt="" class='novice-guide-message' />
        <p>${langCheck("0000PUB-000481")}</p>
        <div class='span-box'>
            <span>${helpHotkeyText}</span>
        </div>
        <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
       `;

        window.useXiaoYou = !!(vpa && groupId !== '' && deployType === 'cloud' && !ispreview);

        return (
            <div className="n-v-middle n-right right-block">
                <div className="container" style={{ flexDirection: 'row' }}>
                    {hideSearch ? null : <SearchApp ispreview={ispreview} />}
                    <ErorrCentorIcon />
                    {is_cloud_register && deployType === 'cloud' && (
                        <div
                            {...(ispreview ? {} : {
                                "data-step": "4",
                                "data-intro": helpCenterIntro
                            })}
                        >
                            <HelpCenter />
                        </div>
                    )}
                    {is_cloud_register && deployType === 'cloud' && im && <IM />}
                    {
                        // 系统管理员不需要
                        userType !== '2' && <div
                            {...(ispreview ? {} : {
                                "data-step": is_cloud_register && deployType === 'cloud' ? '5' : '4',
                                "data-intro": dataIntroMessage
                            })}
                        >
                            <Message
                                getMessage={this.props.getMessage}
                            />
                        </div>
                    }
                    {window.useXiaoYou && <XiaoYou /> /*系统管理员不展示小友*/}
                    {!ispreview && <RecordSPR />}
                </div>
                {/* <span className="block-span" /> */}
                <div
                    {...(ispreview ? {} : {
                        "data-step": is_cloud_register && deployType === 'cloud' ? '6' : '5',
                        "data-intro": dataIntroDate
                    })}
                >
                    <MTZBDate />
                </div>
                <div
                    className="avatar_container"
                    {...(ispreview ? {} : {
                        "data-step": is_cloud_register && deployType === 'cloud' ? '7' : '6',
                        "data-intro": dataIntroUser
                    })}
                >
                    <UserAvatarBtn {...this.props} />
                </div>

            </div>
        );
    }
}
export default HeaderRight;
